import {
	type Control,
	Controller,
	type FieldPath,
	type FieldValues,
} from "react-hook-form";
import {
	FlatRowTextarea,
	type FlatRowTextareaProps,
} from "web_myplann/Shared/Components/FlatRow/FlatRowTextarea";

type Props<
	FormType extends FieldValues,
	TName,
	TContext,
	TTransformed extends FieldValues | undefined,
> = Omit<
	FlatRowTextareaProps,
	"value" | "onChange" | "onBlur" | "inputRef" | "error" | "helperText"
> & {
	control: Control<FormType, TContext, TTransformed>;
	name: TName;
	deps?: FieldPath<FormType>[];
};

export const FlatRowFormTextarea = <
	FormType extends FieldValues,
	TName extends FieldPath<FormType>,
	TContext = unknown,
	TTransformed extends FieldValues | undefined = undefined,
>({
	control,
	name,
	deps,
	...rest
}: Props<FormType, TName, TContext, TTransformed>) => {
	return (
		<Controller
			control={control}
			name={name}
			rules={deps ? { deps } : undefined}
			render={({
				field: { value, onChange, onBlur, ref },
				fieldState: { error },
			}) => (
				<FlatRowTextarea
					{...rest}
					value={value ?? ""}
					onChange={onChange}
					onBlur={onBlur}
					inputRef={ref}
					error={!!error?.message}
					helperText={error?.message}
				/>
			)}
		/>
	);
};
